import { ApplicationExportIcon } from './ApplicationExportIcon';

/**
 * author: Austin Andrews
 * id 19852AF4-396B-4BA7-B9A1-3E412D49290A
 * name application-export
 * version: 3.5.94
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/application-export.svg
 * tags
 */
export const IframeExportOutlineIcon = ApplicationExportIcon;
export default IframeExportOutlineIcon